import { render, staticRenderFns } from "./CartOfferGiftWithPurchase.vue?vue&type=template&id=60227fa1&scoped=true&"
import script from "./CartOfferGiftWithPurchase.vue?vue&type=script&lang=js&"
export * from "./CartOfferGiftWithPurchase.vue?vue&type=script&lang=js&"
import style0 from "./CartOfferGiftWithPurchase.vue?vue&type=style&index=0&id=60227fa1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60227fa1",
  null
  
)

export default component.exports